import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NameFormComponent } from './name-form/name-form.component';
import { AvatarFormComponent } from './avatar-form/avatar-form.component';
import { PasswordFormComponent } from './password-form/password-form.component';
import { BirthdateFormComponent } from './birthdate-form/birthdate-form.component';
import { AlertModule, CardModule, LinkModule, LocalLoaderModule, SosAccountStoreModule, SosAuthorizationStoreModule, SystemIconModule } from '@serviceos-ng/core';
import { InputModule } from '@serviceos-ng/core';
import { AccountCreditComponent } from './account-credit/account-credit.component';
import { AvatarComponent } from './avatar/avatar.component';
import { NamesComponent } from './names/names.component';
import { MemberComponent } from './member/member.component';
import { RouterModule } from '@angular/router';
import { AccountDetailsCardComponent } from './account-details-card/account-details-card.component';


@NgModule({
  declarations: [
    NameFormComponent,
    AvatarFormComponent,
    PasswordFormComponent,
    BirthdateFormComponent,
    AccountCreditComponent,
    AvatarComponent,
    NamesComponent,
    MemberComponent,
    AccountDetailsCardComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    LocalLoaderModule,
    AlertModule,
    InputModule,
    SystemIconModule,
    LinkModule,
    CardModule,
    SosAccountStoreModule,
    SosAuthorizationStoreModule,
  ],
  exports: [
    NameFormComponent,
    AvatarFormComponent,
    PasswordFormComponent,
    BirthdateFormComponent,
    AccountCreditComponent,
    AvatarComponent,
    NamesComponent,
    MemberComponent,
    AccountDetailsCardComponent
  ]
})
export class AccountDetailsModule { }
